import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function ChevronThinNext(props) {
    return (
        <SvgIcon {...props}>
            <path d="M1 1L22.5122 21.4878L1 43" stroke="#F2F2F2" strokeWidth="2" />
        </SvgIcon>
    );
}

ChevronThinNext.defaultProps = {
    viewBox: '0 0 24 44',
    fill: 'transparent',
};

export default ChevronThinNext;
